export const UserSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    className="user-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 20.5C13.784 20.5 15.4397 19.9504 16.8069 19.0112C17.4108 18.5964 17.6688 17.8062 17.3178 17.1632C16.59 15.8303 15.0902 15 11.9999 15C8.90969 15 7.40997 15.8302 6.68214 17.1632C6.33105 17.8062 6.5891 18.5963 7.19296 19.0111C8.56018 19.9503 10.2159 20.5 12 20.5Z"
    />
  </svg>
);

export const ArrowDownSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 1024 1024"
    className="arrow-down-icon"
  >
    <path d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z" />
  </svg>
);

export const CustomUploadIcon = () => (
  <svg
    width="50"
    height="36"
    viewBox="0 0 50 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0625 10.8906C24.5312 10.4219 25.3906 10.4219 25.8594 10.8906L32.1094 17.1406C32.5781 17.6094 32.5781 18.4688 32.1094 18.9375C31.6406 19.4062 30.7812 19.4062 30.3125 18.9375L26.25 14.7969V26.75C26.25 27.4531 25.625 28 25 28C24.2969 28 23.75 27.4531 23.75 26.75V14.7969L19.6094 18.9375C19.1406 19.4062 18.2812 19.4062 17.8125 18.9375C17.3438 18.4688 17.3438 17.6094 17.8125 17.1406L24.0625 10.8906ZM21.25 0.5C25.8594 0.5 30 2.84375 32.5 6.35938C33.5938 5.8125 34.8438 5.5 36.25 5.5C41.0156 5.5 45 9.48438 45 14.25C45 15.1094 44.8438 15.8906 44.6094 16.6719C47.8125 18.3906 50 21.6719 50 25.5C50 31.0469 45.4688 35.5 40 35.5H11.25C5 35.5 0 30.5 0 24.25C0 19.4062 3.125 15.1875 7.5 13.7031C7.8125 6.35938 13.8281 0.5 21.25 0.5ZM21.25 3C15.1562 3 10.2344 7.76562 10 13.7812C9.92188 14.7969 9.29688 15.6562 8.28125 16.0469C4.92188 17.2188 2.5 20.5 2.5 24.25C2.5 29.0938 6.40625 33 11.25 33H40C44.1406 33 47.5 29.6406 47.5 25.5C47.5 22.6875 45.8594 20.1875 43.4375 18.9375C42.4219 18.3125 41.875 17.1406 42.1875 15.9688C42.3438 15.4219 42.5 14.875 42.5 14.25C42.5 10.8125 39.6875 8 36.25 8C35.2344 8 34.375 8.23438 33.5156 8.625C32.4219 9.17188 31.0938 8.78125 30.3906 7.84375C28.3594 4.95312 25 3 21.25 3Z"
      fill="#6c5ffc"
    />
  </svg>
);

export const LanguageSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className="language-icon"
  >
    <path d="M9.99999 1.66663C14.6023 1.66663 18.3333 5.39758 18.3333 9.99996C18.3333 14.6023 14.6023 18.3333 9.99999 18.3333C5.39761 18.3333 1.66666 14.6023 1.66666 9.99996C1.66666 5.39758 5.39761 1.66663 9.99999 1.66663ZM13.3369 10.7314C13.0491 10.2944 12.8414 9.97879 12.0518 10.104C10.5597 10.3408 10.3943 10.602 10.3231 11.0312L10.303 11.1619L10.2827 11.2997C10.2013 11.869 10.2044 12.0843 10.4657 12.359C11.5201 13.4651 12.1517 14.2625 12.343 14.7288C12.4364 14.957 12.6766 15.6459 12.5113 16.3272C13.531 15.9221 14.4297 15.2776 15.1377 14.4632C15.2296 14.1517 15.2959 13.7638 15.2959 13.2931V13.206C15.2959 12.4372 15.2959 12.0866 14.7526 11.7761C14.5233 11.6459 14.3522 11.5675 14.2152 11.5053C13.9092 11.3661 13.7066 11.2747 13.4332 10.8749C13.4006 10.8273 13.3687 10.7798 13.3369 10.7314ZM9.99999 3.1944C8.06882 3.1944 6.32551 3.99878 5.08682 5.29076C5.23429 5.39318 5.3628 5.53707 5.45106 5.73543C5.62106 6.11687 5.62106 6.50929 5.62106 6.85633C5.62072 7.13013 5.62034 7.38929 5.70826 7.57748C5.82868 7.83441 6.34699 7.94352 6.80456 8.03943C6.96804 8.07385 7.13661 8.10898 7.28996 8.15143C7.7117 8.26857 8.03794 8.64704 8.29947 8.95096C8.40799 9.07754 8.56824 9.26354 8.64857 9.30971C8.69049 9.27963 8.82499 9.13396 8.89157 8.89454C8.94224 8.71221 8.92782 8.54971 8.85324 8.46188C8.38732 7.912 8.41266 6.85263 8.55666 6.46242C8.78349 5.84668 9.49207 5.89211 10.01 5.92577C10.2032 5.9382 10.3855 5.95015 10.5214 5.93309C11.0402 5.86801 11.1997 5.07944 11.3125 4.92496C11.5559 4.59147 12.3006 4.08921 12.7632 3.77874C11.9187 3.40314 10.9837 3.1944 9.99999 3.1944Z"></path>
  </svg>
);

export const ArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    className="arrowUp-icon"
  >
    <path
      fill="#000000"
      d="M104.704 685.248a64 64 0 0 0 90.496 0l316.8-316.8 316.8 316.8a64 64 0 0 0 90.496-90.496L557.248 232.704a64 64 0 0 0-90.496 0L104.704 594.752a64 64 0 0 0 0 90.496z"
    />
  </svg>
);

export const MinusIcon = () => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="minus-icon"
    width="13"
    height="13"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" />
  </svg>
);

export const UserIcon = () => (
  <svg className="user-icon" viewBox="0 0 512 512" width="14" height="14">
    <path
      d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <path
      d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="32"
    />
  </svg>
);

export const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="email-icon"
    width="14"
    height="14"
  >
    <g data-name="Layer 2">
      <path
        d="M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-.67 2L12 10.75 5.67 6zM19 18H5a1 1 0 0 1-1-1V7.25l7.4 5.55a1 1 0 0 0 .6.2 1 1 0 0 0 .6-.2L20 7.25V17a1 1 0 0 1-1 1z"
        data-name="email"
      ></path>
    </g>
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    className="plus-icon"
    width="16"
    height="16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="delete-icon"
  >
    <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z" />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    className="info-edit-icon"
  >
    <path d="M16.7574 2.99666L14.7574 4.99666H5V18.9967H19V9.2393L21 7.2393V19.9967C21 20.5489 20.5523 20.9967 20 20.9967H4C3.44772 20.9967 3 20.5489 3 19.9967V3.99666C3 3.44438 3.44772 2.99666 4 2.99666H16.7574ZM20.4853 2.09717L21.8995 3.51138L12.7071 12.7038L11.2954 12.7062L11.2929 11.2896L20.4853 2.09717Z" />
  </svg>
);

export const TransferIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="transfer-icon"
  >
    <path
      d="M14.668 36.3333H34.668M14.668 36.3333L20.5013 30.5M14.668 36.3333L20.5013 42.1666M19.668 19.6666H41.3346M41.3346 19.6666L35.5013 13.8333M41.3346 19.6666L35.5013 25.5"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="28" cy="28" r="27" stroke="#010101" strokeWidth="2" />
  </svg>
);

export const TransferIcon1 = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="transfer-icon1"
  >
    <path d="M14.7907 5.57693C14.9422 4.38964 16.6618 4.38964 16.8133 5.57692L17.7783 13.1416C17.8371 13.6023 18.1998 13.9651 18.6606 14.0239L26.2252 14.9889C27.4125 15.1404 27.4125 16.86 26.2252 17.0114L18.6606 17.9765C18.1998 18.0352 17.8371 18.398 17.7783 18.8587L16.8133 26.4234C16.6618 27.6107 14.9422 27.6107 14.7907 26.4234L13.8257 18.8587C13.7669 18.398 13.4042 18.0352 12.9434 17.9765L5.37875 17.0114C4.19146 16.86 4.19146 15.1404 5.37874 14.9889L12.9434 14.0239C13.4042 13.9651 13.7669 13.6023 13.8257 13.1416L14.7907 5.57693Z" />
    <path d="M22.6553 7.91457C23.6019 7.18214 24.8179 8.39809 24.0854 9.34473L19.4188 15.3761C19.1345 15.7435 19.1345 16.2565 19.4188 16.6239L24.0854 22.6553C24.8179 23.6019 23.6019 24.8179 22.6553 24.0854L16.6239 19.4188C16.2565 19.1345 15.7435 19.1345 15.3761 19.4188L9.34473 24.0854C8.3981 24.8179 7.18213 23.6019 7.91457 22.6553L12.5812 16.6239C12.8655 16.2565 12.8655 15.7435 12.5812 15.3761L7.91457 9.34473C7.18214 8.3981 8.39809 7.18213 9.34473 7.91457L15.3761 12.5812C15.7435 12.8655 16.2565 12.8655 16.6239 12.5812L22.6553 7.91457Z" />
  </svg>
);

export const TransferIcon2 = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="transfer-icon2"
  >
    <path d="M12.1716 1.82842C13.7337 0.266327 16.2663 0.26633 17.8284 1.82843L28.1716 12.1716C29.7337 13.7337 29.7337 16.2663 28.1716 17.8284L17.8284 28.1716C16.2663 29.7337 13.7337 29.7337 12.1716 28.1716L1.82842 17.8284C0.266327 16.2663 0.26633 13.7337 1.82843 12.1716L12.1716 1.82842Z" />
  </svg>
);

export const EditedIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="edited-icon"
  >
    <path
      d="M11.668 6.66675L11.668 26.6667M11.668 6.66675L17.5013 12.5001M11.668 6.66675L5.83463 12.5001M28.3346 11.6667L28.3346 33.3334M28.3346 33.3334L34.168 27.5001M28.3346 33.3334L22.5013 27.5001"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessageSendSvg = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    style={{ cursor: "pointer" }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.2081 2.45514C22.0919 2.3548 21.9505 2.28806 21.7992 2.26213C21.6479 2.23619 21.4923 2.25203 21.3494 2.30795L2.34998 9.74327C2.08071 9.84797 1.85275 10.0373 1.70041 10.2828C1.54806 10.5283 1.47959 10.8166 1.50529 11.1043C1.53098 11.3921 1.64947 11.6637 1.8429 11.8783C2.03633 12.0929 2.29423 12.2389 2.57779 12.2942L7.5006 13.2608V18.7498C7.49963 19.0488 7.58848 19.3412 7.75564 19.5891C7.9228 19.837 8.16056 20.029 8.4381 20.1401C8.71522 20.2533 9.01997 20.2805 9.31274 20.2181C9.6055 20.1557 9.87272 20.0067 10.0797 19.7905L12.4534 17.3286L16.2194 20.6248C16.4911 20.8658 16.8415 20.9992 17.2047 20.9998C17.3638 20.9997 17.522 20.9747 17.6734 20.9258C17.9209 20.8472 18.1434 20.7053 18.3189 20.514C18.4944 20.3227 18.6168 20.0887 18.6737 19.8355L22.479 3.28108C22.5131 3.13178 22.5058 2.97603 22.4581 2.83053C22.4104 2.68503 22.324 2.55527 22.2081 2.45514ZM16.4762 5.83014L8.07717 11.8451L3.42717 10.933L16.4762 5.83014ZM9.0006 18.7498V14.2986L11.3247 16.3367L9.0006 18.7498ZM17.2065 19.4998L9.45529 12.703L20.6115 4.70702L17.2065 19.4998Z"
      fill="white"
    />
  </svg>
);

export const DiscordIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74985 13.1247C9.74985 13.3472 9.68387 13.5647 9.56025 13.7498C9.43663 13.9348 9.26093 14.079 9.05537 14.1641C8.8498 14.2492 8.6236 14.2715 8.40537 14.2281C8.18714 14.1847 7.98669 14.0776 7.82935 13.9202C7.67202 13.7629 7.56487 13.5624 7.52146 13.3442C7.47806 13.126 7.50033 12.8998 7.58548 12.6942C7.67063 12.4887 7.81483 12.3129 7.99983 12.1893C8.18484 12.0657 8.40234 11.9997 8.62485 11.9997C8.92322 11.9997 9.20936 12.1183 9.42034 12.3292C9.63132 12.5402 9.74985 12.8264 9.74985 13.1247ZM15.3748 11.9997C15.1523 11.9997 14.9348 12.0657 14.7498 12.1893C14.5648 12.3129 14.4206 12.4887 14.3355 12.6942C14.2503 12.8998 14.2281 13.126 14.2715 13.3442C14.3149 13.5624 14.422 13.7629 14.5794 13.9202C14.7367 14.0776 14.9371 14.1847 15.1554 14.2281C15.3736 14.2715 15.5998 14.2492 15.8054 14.1641C16.0109 14.079 16.1866 13.9348 16.3102 13.7498C16.4339 13.5647 16.4998 13.3472 16.4998 13.1247C16.4998 12.8264 16.3813 12.5402 16.1703 12.3292C15.9594 12.1183 15.6732 11.9997 15.3748 11.9997ZM22.3545 18.0841L16.0733 20.8694C15.8844 20.9534 15.6804 20.9978 15.4737 21.0001C15.267 21.0023 15.0621 20.9622 14.8714 20.8823C14.6808 20.8024 14.5085 20.6843 14.3652 20.5354C14.2219 20.3865 14.1105 20.2098 14.038 20.0163L13.2777 17.9538C12.8577 17.9819 12.4317 17.9963 11.9998 17.9969C11.568 17.9975 11.142 17.9832 10.722 17.9538L9.96172 20.0163C9.88906 20.2098 9.77764 20.3863 9.63428 20.5352C9.49093 20.684 9.31868 20.802 9.12809 20.8819C8.9375 20.9618 8.7326 21.0019 8.52596 20.9997C8.31932 20.9976 8.1153 20.9532 7.92641 20.8694L1.64516 18.0841C1.32096 17.9424 1.05762 17.6901 0.902063 17.3723C0.746508 17.0545 0.708845 16.6918 0.795785 16.3488L3.56235 5.43724C3.63536 5.15346 3.78954 4.89714 4.00601 4.69965C4.22247 4.50217 4.49183 4.3721 4.7811 4.32536L8.16172 3.76942C8.5344 3.70948 8.91606 3.79029 9.23246 3.99615C9.54886 4.202 9.77739 4.51817 9.8736 4.88317L10.1792 6.08692C10.7748 6.0288 11.3817 5.99974 11.9998 5.99974C12.618 5.99974 13.2242 6.0288 13.8186 6.08692L14.1242 4.88317C14.2202 4.51806 14.4487 4.20175 14.7652 3.99587C15.0816 3.78999 15.4634 3.70926 15.8361 3.76942L19.2186 4.32536C19.5079 4.3721 19.7772 4.50217 19.9937 4.69965C20.2102 4.89714 20.3643 5.15346 20.4373 5.43724L23.2058 16.3479C23.2928 16.6912 23.255 17.0543 23.0991 17.3724C22.9432 17.6904 22.6793 17.9427 22.3545 18.0841ZM21.7498 16.7135L18.9814 5.81224C18.9814 5.81224 18.9814 5.81224 18.9739 5.81224L15.5933 5.24974C15.5909 5.24834 15.5881 5.2476 15.5853 5.2476C15.5825 5.2476 15.5798 5.24834 15.5773 5.24974L15.312 6.29411C15.7808 6.38224 16.2495 6.48724 16.7023 6.61474C16.8809 6.66024 17.0364 6.76986 17.1393 6.92269C17.2421 7.07553 17.2852 7.26088 17.2601 7.4434C17.2351 7.62592 17.1438 7.79285 17.0035 7.91234C16.8633 8.03183 16.684 8.09553 16.4998 8.0913C16.4314 8.0911 16.3633 8.08164 16.2973 8.06317C14.8967 7.6831 13.4512 7.49358 11.9998 7.49974C10.5486 7.49327 9.10306 7.68248 7.70235 8.06224C7.60666 8.09182 7.50602 8.10193 7.40636 8.09199C7.3067 8.08205 7.21004 8.05224 7.12209 8.00434C7.03414 7.95643 6.95667 7.89139 6.89425 7.81306C6.83184 7.73473 6.78575 7.6447 6.7587 7.54827C6.73165 7.45183 6.72419 7.35096 6.73675 7.2516C6.74932 7.15224 6.78166 7.0564 6.83186 6.96974C6.88207 6.88307 6.94912 6.80734 7.02907 6.74702C7.10902 6.68669 7.20024 6.64299 7.29735 6.61849C7.74922 6.49099 8.21422 6.38599 8.68672 6.29786L8.42141 5.24974C8.42141 5.24974 8.42141 5.24974 8.41016 5.24974L5.02578 5.80567C5.02302 5.80491 5.02011 5.80491 5.01735 5.80567L2.24985 16.7182L8.5311 19.4997C8.53426 19.5015 8.53781 19.5024 8.54141 19.5024C8.54501 19.5024 8.54856 19.5015 8.55172 19.4997L9.18735 17.786C8.55049 17.6886 7.92 17.5533 7.29922 17.381C7.11432 17.3219 6.95953 17.1934 6.86738 17.0226C6.77524 16.8517 6.75292 16.6518 6.80513 16.4649C6.85733 16.2779 6.97998 16.1185 7.14731 16.0201C7.31463 15.9217 7.51359 15.892 7.70235 15.9372C9.10297 16.3174 10.5485 16.5067 11.9998 16.4997C13.4511 16.5067 14.8967 16.3174 16.2973 15.9372C16.4889 15.8835 16.694 15.9081 16.8674 16.0056C17.0409 16.1031 17.1685 16.2655 17.2222 16.4571C17.2759 16.6487 17.2513 16.8537 17.1538 17.0272C17.0563 17.2006 16.8939 17.3282 16.7023 17.3819C16.0809 17.554 15.4498 17.6889 14.8123 17.786L15.4452 19.4997C15.4482 19.5014 15.4516 19.5022 15.455 19.5022C15.4584 19.5022 15.4618 19.5014 15.4648 19.4997L21.7498 16.7135Z"
      fill="white"
    />
  </svg>
);
